const notificationSlider = document.querySelectorAll('[data-slider="notifications-modal__slider"]');
const notificationSlides = document.querySelectorAll('.notifications-modal .swiper-slide');
const notificationButtonCount = document.querySelector('.site-header__notification-btn-count');
const notificationsIds = [];

if (notificationSlides) {
  notificationSlides.forEach((el) => {
    notificationsIds.push(el.getAttribute('data-notification-id'));
  });
}

const setNotificationCookie = () => {
  Cookies.set('notifications_IDs', JSON.stringify(notificationsIds), { expires: 365 });
  notificationButtonCount?.remove();
};

const notificationSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  watchOverflow: true,
  keyboard: {
    enabled: true,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 5000,
    pauseOnMouseEnter: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

const toggleNotificationModal = (toggle) => {
  setNotificationCookie();
  const notificationModal = document.querySelector('.notifications-modal');
  notificationModal.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};

notificationSlider.forEach((el) => {
  const parent = el.closest('.notifications-modal');
  const paginationElement = parent.querySelector('.swiper-pagination');
  notificationSliderOptions.pagination.el = paginationElement;

  const arrowRight = parent.querySelector('.arrow-right');
  const arrowLeft = parent.querySelector('.arrow-left');

  notificationSliderOptions.navigation.nextEl = arrowRight;
  notificationSliderOptions.navigation.prevEl = arrowLeft;

  const notificationSwiper = new Swiper(el, notificationSliderOptions);

  const playButton = parent.querySelector('.notifications__play');
  const pauseButton = parent.querySelector('.notifications__pause');

  const toggleButton = (toggle) => {
    playButton.classList.toggle('is-active', !toggle);
    pauseButton.classList.toggle('is-active', toggle);
  };

  const toggleBulletClass = (toggle) => {
    const activeBullet = parent.querySelector('.swiper-pagination-bullet-active');
    activeBullet.classList.toggle('paused', toggle);
    toggleButton(toggle);
  };

  const pauseSlider = () => {
    toggleBulletClass(true);
    notificationSwiper.autoplay.pause();
  };

  const resumeSlider = () => {
    toggleBulletClass(false);
    notificationSwiper.autoplay.resume();
  };

  attachEvent('.notifications__play', 'click', (ev) => {
    resumeSlider();
    ev.preventDefault();
  });

  attachEvent('.notifications__pause', 'click', (ev) => {
    pauseSlider();
    ev.preventDefault();
  });

  attachEvent('[data-notification]', 'click', (ev) => {
    const targetSlide = ev.target.getAttribute('data-notification');
    notificationSwiper.slideTo(targetSlide, 0);
    toggleNotificationModal(true);
    resumeSlider();
    ev.preventDefault();
  });

  notificationSwiper.on('touchStart', () => {
    pauseSlider();
  });

  notificationSwiper.on('touchEnd', () => {
    resumeSlider();
  });

  const bullets = parent.querySelectorAll('.swiper-pagination-bullet');
  notificationSwiper.on('slideChange', (swiper) => {
    bullets.forEach((el, i) => {
      el.classList.toggle('is-filled', i < swiper.activeIndex);
    });
  });
});

// Close Popup When Escape Key Press
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    toggleNotificationModal(false);
  }
});

// Close Popup
attachEvent('[data-close-notifications-modal]', 'click', (ev) => {
  toggleNotificationModal(false);
  ev.preventDefault();
});
